import React from 'react';
import NestedLoader from './nested';

export default NestedLoader;
